
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abbonamenti/caf-patronato",
      function () {
        return require("private-next-pages/abbonamenti/caf-patronato/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abbonamenti/caf-patronato"])
      });
    }
  